import { Vue, Component } from 'vue-property-decorator';
import Form from '../share/form/Form.vue';

@Component({
    components: { Form }
})
class DeeplinksMixin extends Vue {
    processDeeplinks(el: HTMLElement) {
        const links = el.querySelectorAll('a');

        links.forEach(link => {
            let href = link.getAttribute('href');
            if (href && href.startsWith('forms:')) {
                link.addEventListener('click', this.onDeeplinkClicked, { once: true })
            }
        });
    }

    onDeeplinkClicked(e: Event) {
        const link = (e.currentTarget as HTMLAnchorElement);
        e.preventDefault();
        e.stopPropagation();

        const result = link.getAttribute('href')?.match(/forms:\s*\{([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})\}\s*/);
        if (!result) {
            return;
        }

        const formId = result[1];

        const ComponentClass = Vue.extend(Form);
        let instance = new ComponentClass({
            parent: this,
            propsData: { formId }
        });
        instance.$mount();

        link.after(instance.$el);
        link.remove();
    }
}

export default DeeplinksMixin;
